export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/e621f426-7d68-46ac-b7f3-f2311ff9e0c6.jpg';

/** Intent-based entry points under the hero: "what situation are you in?" */
export const entryPaths = [
  { id: 'plug', title: 'Stekkerbatterij', detail: 'Zelf aansluiten op het stopcontact', href: '/shop/plug-in', from: 649 },
  { id: 'home', title: 'Vaste thuisbatterij', detail: 'Aangesloten door een installateur', href: '/shop/home-batteries', from: 2149 },
  { id: 'station', title: 'Powerstation', detail: 'Draagbaar, voor onderweg of noodstroom', href: '/shop/power-stations', from: 199 },
  { id: 'solar', title: 'Zonnepanelen', detail: 'Losse panelen of complete balkonset', href: '/shop/solar-panels', from: 99 },
] as const;

export const trustLine = [
  { lead: 'Meer dan', highlight: '10.000 klanten', tail: 'slaan hun eigen stroom op' },
  { lead: 'Binnen', highlight: '1–2 werkdagen', tail: 'verzonden' },
  { lead: 'Gratis verzending', highlight: 'vanaf € 50', tail: 'in NL & BE' },
];

/** Category showcase tiles. `kind` decides the treatment; deals is the single accent tile. */
const TILE = 'https://cdn.magicpatterns.com/patterns/generated-images/';

/** Category tiles use dedicated portrait shots on one shared backdrop so all tiles read as one set. */
export const showcaseTiles = [
  { id: 'plug-in', eyebrow: 'Plug-in', title: 'Thuisbatterijen', href: '/shop/plug-in', image: `${TILE}31f77a20-219f-4189-a2f1-d103dea75d32.jpg`, kind: 'category', note: 'Vanaf € 649' },
  { id: 'power-stations', eyebrow: 'Draagbare', title: 'Powerstations', href: '/shop/power-stations', image: `${TILE}401c772b-9a53-4f25-9df9-af86f6313577.jpg`, kind: 'category', note: 'Vanaf € 199' },
  { id: 'home-batteries', eyebrow: 'Vaste', title: 'Thuisbatterij\u00ADsystemen', href: '/shop/home-batteries', image: `${TILE}1f96bbcb-7073-4581-9862-e8e39baa4d88.jpg`, kind: 'category', note: 'Vanaf € 2.149' },
  { id: 'bundles', eyebrow: 'Zonnepaneel + powerstation', title: 'Voordeelbundels', href: '/deals', image: `${TILE}c805e5b6-fea4-4167-8f5d-7c1eb55ac403.jpg`, kind: 'bundle', note: 'Tot € 300 voordeel' },
  { id: 'solar-panels', eyebrow: 'Full black & TOPCon', title: 'Zonnepanelen', href: '/shop/solar-panels', image: `${TILE}8ed9a6fa-c926-478e-a1eb-8fd478b20110.jpg`, kind: 'category', note: 'Vanaf € 99' },
  { id: 'inverters', eyebrow: 'Hybride & off-grid', title: 'Omvormers', href: '/shop/inverters', image: `${TILE}dc65bee1-42da-497f-99d8-b268943a2867.jpg`, kind: 'category', note: 'Vanaf € 1.190' },
  { id: 'accessories', eyebrow: 'Meters & kabels', title: 'Accessoires', href: '/shop/accessories', image: `${TILE}68c6b59b-3e14-48db-9553-7bfedbba2e6a.jpg`, kind: 'category', note: 'Vanaf € 24,95' },
  { id: 'deals', eyebrow: 'Tot 25% korting', title: 'Ampra Deals', href: '/deals', image: '', kind: 'deals', note: 'Bekijk alle deals' },
] as const;

export const customerReviews = [
  {
    title: 'Zaterdag besteld, maandag geplaatst',
    text: 'Op zaterdag de Ampra Stack besteld en maandag stond de installateur al voor de deur. Alles netjes uitgelegd, de app werkt perfect.',
    name: 'Marieke V.',
    product: 'Ampra Stack 10,2 kWh',
  },
  {
    title: 'Eerlijk advies, geen verkooppraatje',
    text: 'Ze raadden me het grotere model af omdat ik het niet nodig had. Dat soort eerlijkheid zie je weinig. Snel geleverd en goed verpakt.',
    name: 'Thomas de B.',
    product: 'Zendure SolarFlow 2400',
  },
  {
    title: 'In 10 minuten aangesloten',
    text: 'Stekker erin, app gekoppeld, klaar. Mijn balkonpanelen leveren nu ’s avonds gewoon stroom aan de wasmachine.',
    name: 'Sanne K.',
    product: 'Ampra Plug 2',
  },
  {
    title: 'Probleem binnen een dag opgelost',
    text: 'De omvormer had een software-update nodig. Binnen een dag op afstand opgelost door de technici. Werkt sindsdien vlekkeloos.',
    name: 'Jeroen H.',
    product: 'Ampra Hybride Omvormer',
  },
  {
    title: 'Perfect voor de camper',
    text: 'Een week lang off-grid gestaan met de DELTA 3 Plus en een zonnepaneel. Koelbox, laptop en verlichting zonder één keer bij te laden.',
    name: 'Peter & Linda',
    product: 'EcoFlow DELTA 3 Plus',
  },
  {
    title: 'Netjes op tijd met track & trace',
    text: 'Panelen maandagavond besteld, dinsdag in huis. Vooraf een tijdvak gekregen en de bezorger was precies op tijd.',
    name: 'Bas W.',
    product: 'Aiko Neostar 460 Wp',
  },
];

export const stats = [
  { value: '12.000+', label: 'bestellingen geleverd' },
  { value: '4,8', label: 'gemiddelde reviewscore' },
  { value: '30+', label: 'A-merken op voorraad' },
  { value: '24 uur', label: 'levertijd bij bestelling vóór 22:00' },
];

export const contactInfo = {
  phone: '085 123 4567',
  phoneHref: 'tel:+31851234567',
  whatsappHref: 'https://wa.me/31851234567',
  email: 'info@ampra.nl',
  address: 'Energieweg 12, 3542 DZ Utrecht',
  hours: 'Telefonisch ma t/m za 8:00–20:00 · Showroom op afspraak, 6 dagen per week',
};

export const faqs = [
  {
    q: 'Hoe snel wordt mijn bestelling bezorgd?',
    a: 'Vóór 22:00 besteld is de volgende werkdag in huis, ook grote thuisbatterijen. Pallets bezorgen we met een vooraf gecommuniceerd tijdvak van 2 uur.',
  },
  {
    q: 'Wat kost de bezorging?',
    a: 'Bezorging is gratis in Nederland en België vanaf € 50. Daaronder betaal je € 4,95. Afhalen in onze showroom in Utrecht is altijd gratis.',
  },
  {
    q: 'Kan ik achteraf of in termijnen betalen?',
    a: 'Ja. Met Klarna betaal je binnen 30 dagen of in 3 renteloze termijnen. Je kunt ook betalen met iDEAL, Bancontact, PayPal of creditcard.',
  },
  {
    q: 'Kan ik een stekkerbatterij zelf aansluiten?',
    a: 'Ja. Je zet de batterij neer, steekt de stekker in het stopcontact en koppelt de app. Binnen 15 minuten ben je klaar; er hoeft niets aan je meterkast te gebeuren.',
  },
  {
    q: 'Stekkerbatterij of vaste thuisbatterij — wat past bij mij?',
    a: 'Met 2–6 panelen, een huurwoning of balkonpanelen is een stekkerbatterij ideaal. Heb je 8+ panelen, een warmtepomp of een elektrische auto, dan haal je meer uit een vaste thuisbatterij. Twijfel je? Bel ons, het advies is gratis.',
  },
  {
    q: 'Wat is de laagste prijsgarantie?',
    a: 'Zie je hetzelfde product bij een Nederlandse webshop goedkoper? Laat het ons weten, dan passen we onze prijs aan.',
  },
  {
    q: 'Hoe zit het met garantie?',
    a: 'Op alle producten geldt de volledige fabrieksgarantie, tot 10 jaar op thuisbatterijen. Bij een defect halen wij het product kosteloos op en regelen we de afhandeling met het merk.',
  },
];
